import { render } from "./CustomerEntityTypeSelection.vue?vue&type=template&id=861c520a"
import script from "./CustomerEntityTypeSelection.vue?vue&type=script&lang=js"
export * from "./CustomerEntityTypeSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__